import DynamicSlider from "./DynamicSlider";
import CustomRequestFieldComponent from "./CustomRequestFieldComponent";
import TaskDetailsTab from "../Pages/RequestDashboard/TaskDetailsTab";

export const componentRegistry: Record<string, React.ComponentType<any>> = {
  DynamicSlider,
  //CustomSlider,
//  EvaluationForm,
  TaskDetailsTab
  // Add more components that you trust to render dynamically
};
